import { memoize } from "lodash";
import { splitArrayByIndex } from "app/pages/sales-intelligence/utils/arrays";
import type { TooltipItem } from "../SignalsTooltipViewModel";
import type SignalsTooltipViewModel from "../SignalsTooltipViewModel";
import type TooltipTableColumn from "../TooltipTableColumn";

type TableColumnsResolver = {
    getTableColumns: () => TooltipTableColumn[];
};

type FactoryDeps<T> = {
    values: T[];
    itemsLimit: number;
    tableColumnsResolver: TableColumnsResolver;
};

export default function createSignalsTooltipViewModelFromArray<T extends NonNullable<unknown> = TooltipItem>(
    deps: FactoryDeps<T>,
): SignalsTooltipViewModel<T, TooltipTableColumn> {
    const isItemLimitReached = deps.values.length > deps.itemsLimit;

    const getSplitLists = (): [T[], T[]] => {
        return isItemLimitReached ? splitArrayByIndex(deps.values, deps.itemsLimit) : [deps.values, []];
    };
    const getSplitListsMemoized = memoize(getSplitLists);

    return {
        get visibleItems(): T[] {
            const [displayedTechnologies] = getSplitListsMemoized();

            return displayedTechnologies;
        },

        get otherItems(): T[] {
            const [, remainingTechnologies] = getSplitListsMemoized();

            return remainingTechnologies;
        },

        getPresentationDetailList(): TooltipTableColumn[] {
            return deps.tableColumnsResolver.getTableColumns();
        },
    };
}
